import React from "react";
var FindField = require("../ui_elements/find-field");
import FilterDropdown from "./filter-dropdown";
import { Button } from "@vitalsource/vstui";
import { createThemedComponent } from "@vitalsource/vstui/themes";
import Collections from "../icons/collections";
import cloud from "@vitalsource/vstui/colors/cloud";

const ThemedButton = createThemedComponent(Button, {
  Button_paddingHorizontal_withIconMedium: "12px"
});

/*
  Renders all filtering within a library
    props:
    state:
*/
class FilterContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterString: "",
      visualAmount: 0,
      dropDownMaxWidth: 1000
    };
    this._updateFilterString = this._updateFilterString.bind(this);
    this._showCollections = this._showCollections.bind(this);
    this._updateFilterTextValues = this._updateFilterTextValues.bind(this);
    this._toggleFilterDropdown = this._toggleFilterDropdown.bind(this);
    this._closeFilterDropdown = this._closeFilterDropdown.bind(this);
    this._showFilterDropdown = this._showFilterDropdown.bind(this);

    // Refs
    this.libfilterRef = React.createRef();
    this.iconcontRef = React.createRef();
    this.filterinputRef = React.createRef();
    this.brcontRef = React.createRef();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.loadingBookList &&
      this.props.loadingBookList !== nextProps.loadingBookList
    ) {
      this.setState({ visualAmount: 0 });
    }
  }

  componentDidMount() {
    this._isMounted = true;
    this._updateFilterTextValues();
    if (
      Fraction.Brand.Library.defaultView === "grid" &&
      !Fraction.Brand.Library.gridView
    ) {
      this._showGrid();
    } else if (
      Fraction.Brand.Library.defaultView === "list" &&
      !Fraction.Brand.Library.listView
    ) {
      this._showList();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate() {}

  _updateFilterString(value) {
    this.setState(
      { filterString: value },
      function() {
        this.props.onFilterChange(this.state.filterString);
      }.bind(this)
    );
  }

  _showCollections(e) {
    this.props.openCollections();
  }

  _updateFilterTextValues() {
    var libraryFilterContainer = $(this.libfilterRef.current).width();
    var inputContainer = 230;
    var filterElements = inputContainer - 48;

    if (libraryFilterContainer >= 645) {
      this.props.updatePositionClass(1);
      this.setState({
        dropDownMaxWidth: libraryFilterContainer - filterElements
      });
    } else {
      this.props.updatePositionClass(2);
      this.setState({ dropDownMaxWidth: 500 });
    }
  }

  _toggleFilterDropdown() {
    this.setState(prevState => ({ filterDropdown: !prevState.filterDropdown }));
  }

  _closeFilterDropdown() {
    this.setState({ filterDropdown: false });
  }

  _showFilterDropdown() {
    const props = {
      changeFilter: this.props.changeFilter,
      changeSort: this.props.changeSort,
      close: this._closeFilterDropdown,
      collection: this.props.collection,
      filter: this.props.filter,
      hasBooksRead: this.props.hasBooksRead,
      onViewChange: this.props.onViewChange,
      sort: this.props.sort,
      view: this.props.view,
      filterLabel: i18n.t("library.filter-booklist")
    };

    return (
      <FilterDropdown
        id="toggle-filter-dropdown"
        className={`filter-view`}
        {...props}
      />
    );
  }

  render() {
    var collectionsViewClass = "folder-view";
    var collectionsApplied = "";
    var collectionsShift = "";
    var collectionsAriaPressed = "";

    if (this.props.isCollectionsOpen) {
      collectionsViewClass += " selected";
      collectionsAriaPressed = "true";
      collectionsShift = " collections-shift";
      collectionsApplied = "collections-applied";
    } else {
      collectionsViewClass += "";
      collectionsAriaPressed = "false";
      collectionsShift = "";
      collectionsApplied = "";
    }

    if (this.props.collection) {
      collectionsApplied = "collections-applied";
      collectionsViewClass += " selected";
    } else {
      collectionsApplied = "";
      collectionsViewClass += "";
    }

    var filterPadding = "";
    var filterBottom = false;
    var filterInputPosition = "input-container-outer";
    var mobile = "";
    if (this.props.positionState === 2) {
      mobile = "small-screen";
      filterBottom = true;
      filterPadding = "small-filter";
      filterPadding += this.state.filterDropdown ? " open" : "";
    }

    if (this.state.visualAmount < this.props.totalAmount) {
      setTimeout(
        function() {
          this.setState({
            visualAmount: Math.min(
              this.state.visualAmount + 30,
              this.props.totalAmount
            )
          });
        }.bind(this),
        350
      );
    }
    var resultsContainer = (
      <div
        id="results-container"
        aria-live="assertive"
        aria-atomic="true"
        className={collectionsShift}
      >
        {this.props.loadingBookList && <div className="spinning" />}
        {this.props.loadingBookList ? (
          this.state.filterString.length === 0 ? (
            <p id="book-results-container" ref={this.brcontRef}>
              {i18n.t("library.x-of-x-results", {
                filtered: this.state.visualAmount,
                total: this.props.totalAmount
              })}
            </p>
          ) : (
            <p id="book-results-container" ref={this.brcontRef}>
              {i18n.t("library.x-results", {
                filtered: this.props.filteredAmount || "0"
              })}
            </p>
          )
        ) : (
          <p id="book-results-container" ref={this.brcontRef}>
            {this.props.filteredAmount > 0
              ? i18n.t("library.x-results", {
                  filtered: this.props.filteredAmount
                })
              : i18n.t("library.no-results")}
          </p>
        )}
      </div>
    );

    var filterInputContainer = (
      <div className={filterInputPosition}>
        <div className="input-container">
          <label htmlFor="search">{i18n.t("base.search")}</label>
          <FindField
            type="search"
            className="find"
            placeholder={i18n.t("library.filter")}
            value={this.state.filterString}
            onChange={this._updateFilterString}
            ref={this.filterinputRef}
            focusOnSubmit={this.props.focusOnSubmit}
          />
        </div>
      </div>
    );

    return (
      <div
        id="library-filter"
        className={filterPadding + collectionsShift}
        ref={this.libfilterRef}
      >
        <div id="left-buttons" className={mobile}>
          <div id="filter-dropdown">{this._showFilterDropdown()}</div>
          <div className="icon-container filter-list" ref={this.iconcontRef}>
            {Fraction.Brand.Library.collections && (
              <ThemedButton
                id="folder-view"
                aria-pressed={collectionsAriaPressed}
                color={this.props.isCollectionsOpen ? "theme" : "neutral"}
                colorBehindButton={cloud.getShade(2)}
                iconStart={<Collections />}
                label={i18n.t("collections.collections")}
                naked
                onClick={this._showCollections}
                secondary
                tooltipPlacement="bottom"
              />
            )}
          </div>
          {filterInputContainer}
        </div>
        {!Fraction.Helpers.isSmallScreen() && resultsContainer}
      </div>
    );
  }
}

module.exports = FilterContainer;
